@if (!commonDataService.user.isReadOnly) {
    <div class="integration-block-buttons">
        @if (isServiceNowAvailable) {
            <button
                class="btn btn-transparent btn-lg"
                type="button"
                aria-label="Send to ServiceNow"
                [disabled]="isSendingToServiceNow"
                (click)="sendToServicenow()">
                <div class="d-flex align-items-center">
                    <img src="/assets/images/ServiceNow_logo.png" alt="ServiceNow" style="width: 120px" />
                    @if (ticket.isSentToServiceNow) {
                        <span class="icon-circle active" style="margin-left: 3px"></span>
                    }
                </div>
            </button>
        }
        @if (isIndigoAvailable) {
            <button
                [disabled]="isSendingToIndigo"
                (click)="sendToIndigo()"
                class="btn btn-transparent btn-lg"
                type="button">
                <span>
                    <img
                        src="/assets/images/indigo-logo.png"
                        alt="Indigo"
                        class="pointer"
                        style="width: 30px; vertical-align: middle; margin-right: 8px" />
                    <span style="vertical-align: middle">INDIGO LIGHTHOUSE</span>
                </span>
                @if (ticket.isSentToIndigo) {
                    <span
                        tooltip="{{ 'Sent already' | translate }}"
                        class="icon-circle active"
                        style="vertical-align: middle; margin-left: 3px"></span>
                }
            </button>
        }
        @if (isSuperOfficeAvailable) {
            <button class="btn btn-transparent btn-lg" type="button" (click)="saveToSuperOffice()">
                <span>
                    <img
                        src="../../../assets/images/SuperOffice_logo.svg"
                        alt="SuperOffice"
                        class="pointer"
                        style="height: 30px; vertical-align: middle; margin-right: 8px" />
                    <span style="vertical-align: middle" translate>Save to SuperOffice</span>
                </span>
                @if (ticket.isSentToSupperOffice) {
                    <span
                        class="icon-circle active"
                        style="vertical-align: middle; margin-left: 3px"
                        tooltip="{{ 'The ticket was sent to SuperOffice' | translate }}"></span>
                }
            </button>
        }
        @if (isVoyadoAvailable) {
            <button
                class="btn btn-transparent btn-lg"
                type="button"
                aria-label="Open Voyado"
                (click)="rightPanelService.open(rightPanelTypeEnum.voyado, { email: fistMessageCreatorEmail })">
                <img src="/assets/images/voyado-icon.svg" alt="Voyado" style="width: 120px" />
            </button>
        }
    </div>
}
